<ion-app #ionApp class="m-auto">
  <ng-container *ngIf="versionData$ | async as versionUpdates">
    <ncis-version [versionUpdates]="versionUpdates" (continueEvent)="continueVersion()"></ncis-version>
  </ng-container>

  <ng-container *ngIf="shouldShowTreatmentPlanDialog$ | async">
    <ng-container *ngIf="treatmentPlanData$ | async as treatmentPlanData">
      <ncis-treatment-plan-dialog
        [treatmentPlanData]="treatmentPlanData"
        (continueEvent)="closeTreatmentPlanDialog()"
      ></ncis-treatment-plan-dialog>
    </ng-container>
  </ng-container>
  <cms-spinner-container preserveLatestRequest="true" [id]="SpinnerContainerIds.APPLICATION"></cms-spinner-container>
  <ion-router-outlet id="main"></ion-router-outlet>
</ion-app>
